import { ApiService, SonicPractice } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapSonicPracticeToOptions = (clinics: SonicPractice[]) => [
  { value: undefined, label: "All Sonic Practices", object: undefined },
  ...clinics.map((sonicPractice) => ({
    value: sonicPractice.name,
    label: `${sonicPractice.name}${
      sonicPractice.acronym ? ` (${sonicPractice.acronym})` : ""
    }`,
    object: sonicPractice,
  })),
];

const SonicPracticeFilter = ({
  onChange,
  value,
}: {
  onChange: Function;
  value?: string;
}) => {
  return (
    <SelectSearchInput
      label="Sonic Practice"
      field="Sonic Practice"
      filter="name"
      onChange={onChange}
      mapToOptions={mapSonicPracticeToOptions}
      apiService={ApiService.listSonicPractices}
    >
      <>{value || "All Sonic Practices"}</>
    </SelectSearchInput>
  );
};

export default SonicPracticeFilter;
